import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../ParticipantStore';
import ModalForm from './ModalForm';
import ModalSubmitted from './ModalSubmitted';
import LicenseAllocationsStore from './Store';

interface Props {
  licenseAllocationsStore: LicenseAllocationsStore;
  participantStore: ParticipantStore;
}

function LicenseAllocations({ licenseAllocationsStore, participantStore }: Props) {
  switch (licenseAllocationsStore.state.kind) {
    case 'waiting':
      return <></>;
    case 'loading':
    case 'loading-error':
    case 'ready':
    case 'submitting':
    case 'submitting-error':
      return (
        <ModalForm
          state={licenseAllocationsStore.state}
          licenseAllocationsStore={licenseAllocationsStore}
          participantStore={participantStore}
        />
      );
    case 'submitted':
      return (
        <ModalSubmitted
          state={licenseAllocationsStore.state}
          licenseAllocationsStore={licenseAllocationsStore}
          participantStore={participantStore}
        />
      );
  }
}

export default observer(LicenseAllocations);
